export default __webpack_public_path__ + "static/media/flashlight.84ff635c.svg";